import { render, staticRenderFns } from "./_base-loading.vue?vue&type=template&id=31771e82&"
import script from "./_base-loading.vue?vue&type=script&lang=js&"
export * from "./_base-loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31771e82')) {
      api.createRecord('31771e82', component.options)
    } else {
      api.reload('31771e82', component.options)
    }
    module.hot.accept("./_base-loading.vue?vue&type=template&id=31771e82&", function () {
      api.rerender('31771e82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base-loading.vue"
export default component.exports